import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { TItemsAddsSlider } from "../../types/addsSlider";
import $api, { API } from "../index";
import {
  IGetHomePageSettingResponse,
  TAudioPreRoll,
  TSEOSettingsDefault,
} from "../../types/settings";

export const getAddsSliderImgs = createAsyncThunk(
  "getAddsSliderImgs",
  async (_, { rejectWithValue }): Promise<TItemsAddsSlider[]> => {
    try {
      const data = await $api.get(`${API.addsSliderPath}`);

      return data.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const getHomePageSetting = createAsyncThunk(
  "getHomePageSetting",
  async (_, { rejectWithValue }): Promise<IGetHomePageSettingResponse> => {
    try {
      const response = await $api.get(`${API.settings}${API.settingHomePage}`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const getSEOSettings = createAsyncThunk(
  "getSEOSettings",
  async (_, { rejectWithValue }): Promise<TSEOSettingsDefault> => {
    try {
      const response = await $api.get(`${API.getSEOSettings}`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const getDefaultCovers = createAsyncThunk(
  "getDefaultCovers",
  async (_, { rejectWithValue }): Promise<string> => {
    try {
      const response = await $api.get(`${API.getDefaultCovers}`);

      return response.data.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const getPreRoll = createAsyncThunk(
  "getPreRoll",
  async (_, { rejectWithValue }): Promise<TAudioPreRoll> => {
    try {
      const response = await $api.get(`${API.getPreRoll}`);

      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);
